export default __webpack_public_path__ + "static/media/1.137d80a9.jpg";